import React from 'react'
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <>
      <nav className="navbar navbar-expand-lg p-0 m-0 sticky-top">
        <div className="container-fluid">
          <Link className="navbar-brand text-light" to="/">
            <img src="img/logoMartin.png" className="imgLogo" alt="Logo ElectroBazar Distribuciones"/>
          </Link>
          <button className="navbar-toggler colorNav" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <Link className="nav-link active text-light fw-semibold"  aria-current="page" to="/">Inicio</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-light fw-semibold" to="/productos">Productos</Link>
              </li>
             {/*<li className="nav-item">
                <Link className="nav-link text-light fw-semibold" to="/revendedores">Mayorista</Link>
              </li>*/}
              <li className="nav-item">
                <Link className="nav-link text-light fw-semibold" to="/about">Sobre Nosotros</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link text-light fw-semibold" to="/contacto">Contacto</Link>
              </li>
            </ul>
           
            <div className="">
          
              <Link to="/carrito">
                <i className="fa-sharp fa-solid fa-cart-shopping"></i>
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar